<template>
  <aside id="text-2" class="widget widget_text">
    <div
      class="h3 widgettitle mobile-title"
      :class="{ tablet: $mq.phone }"
      @click.prevent="$mq.phone ? onToggle() : ''"
    >
      {{ $t('products')
      }}<span
        v-if="$mq.phone"
        :class="`seasidetms_theme_icon_slide_${isOpen ? 'bottom' : 'top'}`"
      ></span>
    </div>
    <slide-up-down
      :active="$mq.phone ? !isOpen : isOpen"
      :duration="500"
      ref="footer_menu"
      :class="{ show: $mq.phone }"
    >
      <div class="textwidget">
        <ul>
          <li v-for="item in categories" :key="item.slug">
            <router-link
              :to="
                lang
                  ? '/' + lang + '/product-category/' + item.slug
                  : '/product-category/' + item.slug
              "
            >
              {{ categoryName(item) }}
            </router-link>
          </li>
        </ul>
      </div>
    </slide-up-down>
  </aside>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'FooterCategoriesMenu',
  data() {
    return {
      isOpen: true,
      lang: '',
    }
  },
  computed: {
    ...mapState(['categories']),
  },
  methods: {
    categoryName(cat) {
      return cat[`name_${this.$i18n.locale}`]
    },
    onToggle() {
      this.isOpen = !this.isOpen
    },
  },
  beforeMount() {
    this.lang = this.$store.getters.lang
  },
  updated() {
    this.lang = this.$store.getters.lang
  },
}
</script>

<style></style>
